// External libraries
import { capitalizeFirst } from '@checkout/react-components';

// Internal modules
import { appStore } from '@/store';
import { features } from '@/lib';

export const uncheckPreviousTermBox = option => {
  const { updateNonAddressField } = appStore.getActions().form;

  const prevOption = option === 'guest' ? 'signup' : 'guest';
  const termsCheckboxField = `${prevOption}AgreeToTerms`;

  updateNonAddressField({
    field: termsCheckboxField,
    payload: {
      displayError: false,
      error: '',
      errorCode: 'valueMissing',
      isValid: features.isNotActive(
        `has${capitalizeFirst(prevOption)}TermsAndConditionsCheckbox`,
      ),
      value: false,
    },
  });
};
